import type { Member } from '@typings/membership';

export const createRfqFieldsFromMember = (member: Member) => ({
	emailAddress: {
		error: '',
		label: 'Email',
		state: 'default',
		value: member.email,
	},
	firstName: {
		error: '',
		label: 'First name',
		state: 'default',
		value: member.first_name,
	},
	lastName: {
		error: '',
		label: 'Last name',
		state: 'default',
		value: member.last_name,
	},
	phoneNumber: {
		error: '',
		label: 'Phone number',
		state: 'neutral',
		value: member.phone_number,
	},
	textarea: { error: '', label: '', state: '', value: '' },
	weddingDate: {
		error: '',
		label: 'Wedding date',
		state: 'default',
		value: member.wedding_date,
	},
	guestCount: {
		error: '',
		label: 'Number of guests',
		state: 'default',
		value: member.number_of_guests?.toString(),
	},
});
